import ConsentPromptLayout from './ConsentPromptLayout'

export default ConsentPromptLayout
